
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { requiredWhenPresent } from '../../shared/propTypes';

import FormikProvider from '../../shared/forms/formikProvider.component';
import Modal from '../../shared/modals/modal.component';
import Form from '../../shared/forms/form.component';

import schema from './tagForm.schema';
import { OptionsPropType } from '../../shared/propTypes/common';

import {
  hideTagsModalForAddEdit,
  saveTag,
} from './store/actions';

import {
  isSavingTagInProgressSelector,
  subTagsListSelector,
  tagsListSelector,
} from './store/selectors';
import { tagsPropTypes } from './propTypes';

const ModalTitles = {
  ADD: 'Add Tag',
  EDIT: 'Edit Tag',
};

class AddTagModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func.isRequired,
    saveEntity: PropTypes.func.isRequired,
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    category: PropTypes.string.isRequired,
    entityToEdit: requiredWhenPresent(['isVisible'], PropTypes.shape({
      tagName: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      subTagName: PropTypes.string,
    })),
    isSavingInProgress: PropTypes.bool.isRequired,
    openForEdit: PropTypes.bool,
    isVisible: PropTypes.bool,
    tagsList: PropTypes.arrayOf(tagsPropTypes),
    subTagsListOptions: OptionsPropType,
  };

  state = {
    addAnother: false,
  };

  save = (tagData, { setSubmitting, resetForm }) => {
    const { period, category, saveEntity, openForEdit } = this.props;
    const { addAnother } = this.state;
    const { subTag, ...restTagData } = tagData;

    this.setState({ addAnother: false }, () => {
      saveEntity({
        tagData: {
          ...restTagData,
          subTagName: tagData.subTag,
        },
        periodName: period.name,
        category,
      }, openForEdit, { callback: resetForm, keepOpenAfterSaving: addAnother });
      setSubmitting(false);
    });
  };

  renderModal = ({ formik, schema }) => {
    const {
      openForEdit,
      hideModal,
      isVisible,
      isSavingInProgress,
      subTagsListOptions,
    } = this.props;

    const submit = () => {
      this.setState({
        addAnother: false,
      }, () => formik.handleSubmit());
    };

    const submitAndAddAnotherAction = () => {
      this.setState({
        addAnother: true,
      }, () => formik.handleSubmit());
    };

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="add-tag-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save"
        submitAction={submit} // eslint-disable-line react/jsx-no-bind
        isSubmitting={formik.isSubmitting || isSavingInProgress}
        submitAndAddAnotherAction={!openForEdit ? submitAndAddAnotherAction : null}
        submitAndAddAnotherText="Save and Add Another"
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={{
            subTagsListOptions,
          }}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit, tagsList, openForEdit } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.save}
        render={this.renderModal}
        validationContext={{ entities: tagsList, openForEdit }}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    isSavingInProgress: isSavingTagInProgressSelector(state),
    tagsList: tagsListSelector(state),
    subTagsListOptions: subTagsListSelector(state),
  };
}

export default connect(
  mapStateToProps,
  {
    hideModal: hideTagsModalForAddEdit,
    saveEntity: saveTag,
  }
)(AddTagModal);
